import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useFeatureEnabled } from 'core/feature/hooks'
import { isFeatureEnabled } from 'core/feature/selectors'
import store from 'store'

export const INTERNATIONALIZATION_FEATURE = 'Internationalization'

export function useInternationalizationEnabled() {
  return useFeatureEnabled(INTERNATIONALIZATION_FEATURE)
}

export function isInternationalizationEnabled(state = store.getState()) {
  return isFeatureEnabled(state, INTERNATIONALIZATION_FEATURE)
}

/**
 * When Internationalization is off, returns master-era copy via `defaultValue` (or English t fallback).
 */
export function useAdminI18n(ns = 'admin') {
  const enabled = useInternationalizationEnabled()
  const { t: translate } = useTranslation(ns)

  const t = useCallback(
    (key, options) => {
      if (!enabled) {
        if (options?.defaultValue != null) {
          return options.defaultValue
        }
        return translate(key, { ...options, lng: 'en' })
      }
      return translate(key, options)
    },
    [enabled, translate],
  )

  return { t, enabled }
}
